<template>
  <div class="person">
    <nav-bar navBarTitle="个人资料"></nav-bar>
    <div class="person-form">
      <div class="person-form-item">
        <div class="form-item-l">头像</div>
        <div class="form-item-c">
          <van-uploader :after-read="afterRead">
            <img :src="avatar" alt="" />
          </van-uploader>
        </div>
        <div class="form-item-r">
          <span class="icon iconfont iconfanhui2"></span>
        </div>
      </div>
      <div class="person-form-item" @click="showName = true">
        <div class="form-item-l">真实姓名</div>
        <div class="form-item-c ellipsis">{{ defaultUserName ?  '' : params.userName }}</div>
        <div class="form-item-r">
          <span class="icon iconfont iconfanhui2"></span>
        </div>
      </div>
      <div class="person-form-item" @click="showPosition = true">
        <div class="form-item-l">公司职务</div>
        <div class="form-item-c ellipsis">{{ info.companyPosition }}</div>
        <div class="form-item-r">
          <span class="icon iconfont iconfanhui2"></span>
        </div>
      </div>
      <div class="person-form-item" @click="handleBirth">
        <div class="form-item-l">生日</div>
        <div class="form-item-c">{{ info.birth }}</div>
        <div class="form-item-r">
          <span class="icon iconfont iconfanhui2"></span>
        </div>
      </div>
    </div>
    <!--姓名-->
    <single-input-pop
      v-if="showName"
      title="真实姓名"
      :value="defaultUserName ? '' : info.userName "
      :maxlength="20"
      @onSubmit="getValue($event, 'userName')"
      :show.sync="showName"
      :require="true"
      name="name"
    ></single-input-pop>
    <!--选择职位-->
    <single-input-pop
      v-if="showPosition"
      title="公司职务"
      :value="info.companyPosition"
      :label-list="labelList"
      :maxlength="20"
      @onSubmit="getValue($event, 'companyPosition')"
      :show.sync="showPosition"
      :require="true"
      name="companyPosition"
    ></single-input-pop>
    <!--选择年月日-->
    <van-popup v-model="showDate" closeable close-icon-position="top-left" round position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="你的生日"
        :formatter="formatter"
        cancel-button-text=" "
        @cancel="showDate = false"
        @confirm="setDate"
        :max-date="maxDate"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>

<script>
import SingleInputPop from '../../components/SingleInputPop'
import { extend, formatDate } from '../../utils'
import { mapGetters, mapMutations } from 'vuex'
import { reqFileUpload } from '../../api/api_base'
import { reqPositonList, reqUpdateInfo } from '../../api'
export default {
  name: 'person',
  components: {
    SingleInputPop,
  },
  created() {
    this.getPositionList()
  },
  mounted() {
    extend(this.params, this.info)
  },
  computed: {
    avatar: {
      get() {
        return this.info.avatar ? this.info.avatar : require('../../assets/img/member/profile.png')
      },
    },
    ...mapGetters({
      info: 'person',
      defaultUserName:'defaultUserName'
    }),
  },
  data() {
    return {
      params: {
        avatar: '',
        userName: '',
        companyPosition: '',
        birth: '',
        userId: '',
      },
      showName: false,
      showPosition: false,
      showDate: false,
      labelList: [],
      currentDate: new Date(),
      maxDate: new Date(new Date().getTime() - 24 * 60 * 60 * 1000), // 生日最大限制时间:只能选择今天以前
      minDate: new Date(1920, 0, 1),
    }
  },
  methods: {
    ...mapMutations({
      setPerson: 'SET_PERSON',
      hasEditName: 'HAS_EDITNAME'
    }),
    //  获取职务列表
    getPositionList() {
      reqPositonList().then(res => {
        let resData = res.data
        if (resData.length) {
          this.labelList = resData.map(item => {
            return item.positionName
          })
        }
      })
    },
    // 选择生日
    handleBirth() {
      this.showDate = true
      this.info.birth ? (this.currentDate = new Date(this.info.birth)) : (this.currentDate = new Date())
    },
    //  图片上传回调
    afterRead(file) {
      const formdata = new FormData()
      formdata.append('files', file.file)
      formdata.append('business', 'avatar')
      reqFileUpload(formdata).then(res => {
        if (res.data.length) {
          this.params.avatar = res.data[0]
          // 存入数据库
          this.updateInfo('avatar', { avatar: this.params.avatar })
        }
      })
    },
    // 选择时间组件格式化
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    // 修改姓名和职务
    getValue($event, key) {
      this.params[key] = $event
      if (key === 'userName') {
        this.updateInfo('userName', { userName: this.params.userName })
        this.hasEditName()
      }
      if (key === 'companyPosition') {
        this.updateInfo('companyPosition', { companyPosition: this.params.companyPosition })
      }
    },
    // 选择生日
    setDate() {
      this.showDate = false
      this.params.birth = formatDate(this.currentDate, 'yyyy-MM-dd')
      this.updateInfo('birth', { birth: this.params.birth })
    },
    // 更新用户信息
    updateInfo(key, newParams) {
      newParams.birth ? (newParams.birth = newParams.birth.replace(/-/g, '.')) : ''
      reqUpdateInfo(newParams)
        .then(res => {
          if (res.ok) {
            // 更新本地缓存
            this.setPerson(this.params)
          } else {
            this.params[key] = ''
          }
        })
        .catch(() => {
          this.params[key] = ''
        })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-picker__toolbar {
  margin-top: 10px;
}
/deep/ .van-popup__close-icon--top-left{
	top: 20px;
}
/deep/ .van-picker__title {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 18px;
  margin-left: 25px;
}
/deep/ .van-picker__confirm {
  color: #000000;
}
/deep/ .van-picker__columns {
  margin-top: 30px;
}
.person {
  height: 100%;
  background: #f5f5f5;
  padding-top: 10px;
  .person-form {
    background: #ffffff;
    padding: 0 0px 0px 16px;
    .person-form-item {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      border-bottom: 0.5px solid #eeeeee;
      font-size: 16px;
      .form-item-c {
        flex: 1;
        text-align: right;
        margin: 0 16px;
      }
      .form-item-r {
        margin-right: 16px;
      }
      img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
}
</style>
